const ValidatorOrt = (ort) => {

    if (!ort.meta.touched) {
        return {
            valid:true,
            message: [],
        }        
    }
    var msg = []

    if ( !checkAllPropsOk(ort) ) {
        msg.push("Bitte korrigieren Sie die rot markierten Felder")
    }

    return {
        valid:(msg.length < 1),
        message: msg,
    }

}

const checkAllPropsOk = (ort) => {
    for (let item in ort) {
        if (ort[item].valid === false) {
            return false;
        }
    }
    return true;
}

export default ValidatorOrt;
